export const REDUX_SET = '/redux/container/VehicleEditContainer/set';
export const REDUX_RESET = '/redux/container/VehicleEditContainer/reset';
